export default __webpack_public_path__ + "static/media/memorabilia_light.07162118.png";